/**
 * Minimal hyperscript. Everything the page renders goes through here, which
 * means every string lands via textContent — there is no innerHTML path for
 * content to slip through, including anything typed into the enquiry form.
 */

const SVG_NS = 'http://www.w3.org/2000/svg';

export function h(tag, props = null, ...children) {
  const node =
    props && props.xmlns === SVG_NS
      ? document.createElementNS(SVG_NS, tag)
      : document.createElement(tag);

  for (const [key, value] of Object.entries(props || {})) {
    if (value == null || value === false) continue;
    if (key === 'class') node.className = value;
    else if (key === 'dataset') Object.assign(node.dataset, value);
    else if (key.startsWith('on') && typeof value === 'function') {
      node.addEventListener(key.slice(2).toLowerCase(), value);
    } else if (key === 'html') node.innerHTML = value; // never used with dynamic input
    else node.setAttribute(key, value === true ? '' : String(value));
  }

  append(node, children);
  return node;
}

function append(node, children) {
  for (const child of children) {
    if (child == null || child === false) continue;
    if (Array.isArray(child)) append(node, child);
    else node.append(child instanceof Node ? child : document.createTextNode(String(child)));
  }
}

/** Replace a container's children with new ones in a single operation. */
export function mount(container, ...children) {
  container.replaceChildren();
  append(container, children);
  return container;
}
